/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowUpRightFromSquare, faArrowRight } from 'icons'
import { icons } from "icons";

const CTAStyleLink = (props) => {
    const link = props?.link;
    const style = props?.style;
    const format = props?.format;
    const link_type = link?.link_type;
    const isExternalLink = link_type === "external";
    const isInternalLink = link_type === "internal";
    const isIntegrationLink = link_type === "integration";
    const isMailtoLink = link_type === "mailto";

    const openInNewTab = link?.new_tab || isExternalLink;
    const linkTarget = openInNewTab ? "_blank" : "_self";

    return (
        <div className="simplicity-text-link-item">
            <a
                href={link?.url}
                className={`simplicity-cta-link ${style} ${format} ${
                    isExternalLink || isInternalLink || isMailtoLink || isIntegrationLink
                        ? "link--icon link--icon--left"
                        : ""
                }`}
                target={linkTarget}
            >
                {link?.text}

                {isInternalLink && (
                    <span className="simplicity-link-icon">
                        <FontAwesomeIcon icon={icons.regular.faArrowRight} size="1x" />
                    </span>
                )}
                {isExternalLink && (
                    <span className="simplicity-link-icon">
                        <FontAwesomeIcon icon={icons.regular.faArrowUpRightFromSquare} size="1x" />
                    </span>
                )}
                {isMailtoLink && (
                    <span className="simplicity-link-icon">
                        <FontAwesomeIcon icon={icons.regular.faArrowRight} size="1x" />
                    </span>
                )}
                {isIntegrationLink && (
                    <span className="simplicity-link-icon">
                        <FontAwesomeIcon icon={icons.regular.faArrowRight} size="1x" />
                    </span>
                )}
            </a>
        </div>
    );
};

export { CTAStyleLink };
